<template>
    <div class="">
        <v-card-title class="headline pt-1 pb-2 px-0">{{
            schedulePayments ? "Schedules" : "Details"
        }}</v-card-title>

        <div v-if="paymentType == 'Cash/Check'">
            <div v-for="(check, index) in checkDetails">
                <v-layout row>
                    <v-layout column>
                        <v-layout row>
                            <v-text-field
                                class="px-1 mr-1"
                                label="Check Number"
                                v-model="check.checkNumber"
                            ></v-text-field>
                            <v-text-field
                                class="px-1 mr-1"
                                label="Amount"
                                placeholder="Amount"
                                v-model="check.amount"
                                @input="checkAmountChanged"
                                prefix="$"
                                type="number"
                            ></v-text-field>
                            <v-menu
                                v-if="schedulePayments"
                                v-model="check.datePickerMenu"
                                :close-on-content-click="false"
                                offset-y
                                full-width
                                prepend-icon="mdi-currency-usd"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-text-field
                                        v-model="check.date"
                                        :value="formatedDate(check.date)"
                                        label="Date"
                                        prepend-icon="mdi-calendar"
                                        readonly
                                        v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="check.date"
                                ></v-date-picker>
                            </v-menu>
                        </v-layout>
                    </v-layout>
                    <v-layout
                        align-center
                        v-bind:class="{ 'mr-3': schedulePayments }"
                    >
                        <v-btn @click="addCheck" flat icon color="success">
                            <v-icon>mdi-plus-circle</v-icon>
                        </v-btn>
                        <v-btn
                            :disabled="index == 0"
                            @click="removeCheck(index)"
                            flat
                            icon
                            color="#f55a4e"
                        >
                            <v-icon>mdi-minus-circle-outline</v-icon>
                        </v-btn>
                    </v-layout>
                </v-layout>
            </div>
        </div>
        <div v-else>
            <v-menu
                v-model="startDatePickerMenu"
                :close-on-content-click="true"
                offset-y
                prepend-icon="mdi-currency-usd"
            >
                <template v-slot:activator="{ on }">
                    <v-text-field
                        class=""
                        v-model="startDate"
                        label="Start Date"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-on="on"
                    ></v-text-field>
                </template>
                <v-date-picker
                    @change="startDateChanged"
                    v-model="startDate"
                    :min="date"
                ></v-date-picker>
            </v-menu>
            <v-text-field
                class="mt-1 mb-0 ml-1"
                type="number"
                label="HOW MANY PAYMENTS?"
                v-model="scheduleCount"
                color="success"
                :rules="scheduleCountRules"
                @input="scheduleCountChanged"
            ></v-text-field>
            <v-btn-toggle
                mandatory
                v-model="scheduleMode"
                class="mb-3"
                @change="scheduleModeChanged"
            >
                <v-btn value="month">
                    Month
                </v-btn>
                <v-btn value="week">
                    Week
                </v-btn>
            </v-btn-toggle>
            <div v-for="(schedule, index) in schedules">
                <v-layout row>
                    <v-text-field
                        class="px-1 mr-1"
                        label="Amount"
                        placeholder="Amount"
                        v-model="schedule.amount"
                        @input="amountChanged"
                        type="number"
                        prefix="$"
                    ></v-text-field>
                    <v-menu
                        v-model="schedule.datePickerMenu"
                        :close-on-content-click="false"
                        offset-y
                        full-width
                        prepend-icon="mdi-currency-usd"
                    >
                        <template v-slot:activator="{ on }">
                            <v-text-field
                                v-model="schedule.date"
                                :value="formatedDate(schedule.date)"
                                label="Date"
                                prepend-icon="mdi-calendar"
                                readonly
                                v-on="on"
                            ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="schedule.date"
                            :min="startDate"
                        ></v-date-picker>
                    </v-menu>
                    <!-- <v-btn @click="addSchedule" flat icon color="success">
                        <v-icon>mdi-plus-circle</v-icon>
                    </v-btn>
                    <v-btn
                        :disabled="index == 0"
                        @click="removeSchedule(index)"
                        flat
                        icon
                        color="#f55a4e"
                    >
                        <v-icon>mdi-minus-circle-outline</v-icon>
                    </v-btn> -->
                </v-layout>
            </div>
        </div>

        <v-card-title v-if="schedulesDiscrepancy" class="pa-2">
            <div class="font-weight-regular" style="color: #D50000">
                {{ schedulePayments ? "Schedule " : "Detail " }} amounts does
                not match the total
            </div>
        </v-card-title>
    </div>
</template>

<script>
import moment from "moment";
import { toISOLocal } from "../../utils/helpers.js";

export default {
    props: {
        schedules: Array,
        addSchedule: Function,
        removeSchedule: Function,
        addCheck: Function,
        removeCheck: Function,
        schedulesDiscrepancy: Boolean,
        schedulePayments: Boolean,
        paymentType: String,
        updateSchedules: Function,
        updateChecks: Function,
        checkDetails: Array,
    },
    data() {
        return {
            date: new Date().toISOString().substr(0, 10),
            startDatePickerMenu: false,
            startDate: toISOLocal(new Date(moment())).substr(0, 10),
            scheduleCount: 1,
            scheduleMode: "month",
            scheduleCountRules: [
                (value) => !!value || "Required",
                (value) => {
                    return !value || value >= 1 || "Must be at least 1";
                },
            ],
        };
    },
    created() {},
    computed: {},
    methods: {
        formatedDate(date) {
            return date ? moment(date).format("L") : "";
        },
        amountChanged(amount) {
            this.updateSchedules("scheduleAmountChange");
        },
        startDateChanged() {
            this.updateSchedules();
        },
        scheduleModeChanged() {
            this.updateSchedules();
        },
        scheduleCountChanged() {
            this.updateSchedules();
        },
        checkAmountChanged(amount) {
            this.updateChecks("checkAmountChanged");
        },
        clearScheduleCount() {
            this.scheduleCount = 1;
        },
    },
};
</script>
